import { render, staticRenderFns } from "./private-fl223-contract-customer-block.vue?vue&type=template&id=8309d642&"
import script from "./private-fl223-contract-customer-block.vue?vue&type=script&lang=js&"
export * from "./private-fl223-contract-customer-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8309d642')) {
      api.createRecord('8309d642', component.options)
    } else {
      api.reload('8309d642', component.options)
    }
    module.hot.accept("./private-fl223-contract-customer-block.vue?vue&type=template&id=8309d642&", function () {
      api.rerender('8309d642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/private-fl223-contract-customer-block.vue"
export default component.exports